import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export const characteristicsApi = createApi({
    reducerPath: 'characteristicsApi',
    baseQuery: (fetchBaseQuery({
        baseUrl: `${process.env.REACT_APP_BACKEND_HOST}/api/admin/characteristics`, prepareHeaders: (headers) => {
            const token = localStorage.getItem('prona_userToken');
            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }
            return headers;
        },
    })),
    endpoints: (build) => ({
        getCharacteristics: build.query({
            query() {
                return {
                    url: '/getAll',
                    params: {},
                    method: 'GET',
                    headers: {}
                }
            },
            providesTags: ['Characteristics']
        }),
        createCharacteristic: build.mutation({
            query: (data) => ({
                url: '/create',
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['Characteristics']
        }),
        deleteCharacteristic: build.mutation({
            query(id) {
                return {
                    url: `/delete/${id}`,
                    method: 'DELETE',
                }
            },
            invalidatesTags: ['Characteristics']
        }),
        updateCharacteristic: build.mutation({
            query({ id, data }) {
                return {
                    url: `/update/${id}`,
                    method: 'PUT',
                    body: data
                }
            },
            invalidatesTags: ['Characteristics']
        }),
    }),
});

export const {
    useLazyGetCharacteristicsQuery,
    useGetCharacteristicsQuery,
    useCreateCharacteristicMutation,
    useDeleteCharacteristicMutation,
    useUpdateCharacteristicMutation
} = characteristicsApi;